import {
  Box,
  Button,
  Flex,
  Modal,
  Radio,
  Typography,
  useDevice,
} from '@ergolabs/ui-kit';
import React, { FC, ReactNode, useState } from 'react';
import { Observable } from 'rxjs';

import { submitRedeemTx } from '../../../api/redeemSpf/submitRedeemTx';
import { VestingItem } from '../../../api/vesting/vesting';
import { spfAsset } from '../../../common/assets/spfAsset';
import { AssetIcon } from '../../../common/components/AssetIcon/AssetIcon';
import { TxId } from '../../../common/types';

export interface ClaimConfirmationModalProps {
  readonly title: ReactNode;
  readonly onClose: (p: Observable<TxId>) => void;
  readonly vestingItems: VestingItem[];
}

export const ClaimConfirmationModal: FC<ClaimConfirmationModalProps> = ({
  vestingItems,
  onClose,
}) => {
  const { s } = useDevice();

  const [selectedVestingItem, setSelectedVestingItem] = useState<
    VestingItem | undefined
  >(undefined);

  const claimSpf = () => {
    if (selectedVestingItem) {
      onClose(submitRedeemTx(selectedVestingItem));
    }
  };

  return (
    <>
      <Modal.Title>SPF claiming</Modal.Title>
      <Modal.Content maxWidth={720} width="100%">
        <Flex col>
          {!s && (
            <Flex.Item marginBottom={2}>
              <Box padding={[2, 0, 2, 14]} borderRadius="l" secondary>
                <Flex align="center">
                  <Flex.Item width={213} marginRight={2}>
                    <Typography.Body strong>Tokens remaining</Typography.Body>
                  </Flex.Item>
                  <Flex.Item width={213} marginRight={2}>
                    <Typography.Body strong>
                      Tokens redeemable now
                    </Typography.Body>
                  </Flex.Item>
                  <Flex.Item flex={1}>
                    <Typography.Body strong>Next unlock</Typography.Body>
                  </Flex.Item>
                </Flex>
              </Box>
            </Flex.Item>
          )}
          {vestingItems.map((vi, index) => (
            <Flex.Item
              key={vi.boxId}
              marginBottom={vestingItems.length - 1 === index ? 6 : 2}
            >
              <Box
                padding={[2, 0, 2, 4]}
                borderRadius="l"
                secondary
                onClick={() => setSelectedVestingItem(vi)}
                style={{
                  borderColor:
                    selectedVestingItem?.boxId === vi.boxId
                      ? 'var(--spectrum-primary-color)'
                      : undefined,
                }}
              >
                <Flex align="center">
                  <Flex.Item width={32} marginRight={2}>
                    <Radio checked={selectedVestingItem?.boxId === vi.boxId} />
                  </Flex.Item>
                  <Flex.Item width={213} marginRight={2}>
                    <Flex align="center">
                      <Flex.Item marginRight={1}>
                        <AssetIcon asset={spfAsset} size="extraSmall" />
                      </Flex.Item>
                      <Typography.Body strong>{vi.remaining}</Typography.Body>
                    </Flex>
                  </Flex.Item>
                  <Flex.Item width={213} marginRight={2}>
                    <Flex align="center">
                      <Flex.Item marginRight={1}>
                        <AssetIcon asset={spfAsset} size="extraSmall" />
                      </Flex.Item>
                      <Typography.Body strong>{vi.redeemable}</Typography.Body>
                    </Flex>
                  </Flex.Item>
                  <Flex.Item flex={1}>
                    <Typography.Body strong>
                      {vi.nextUnlock.toFormat('dd-MM-yyyy HH:mm:ss')}
                    </Typography.Body>
                  </Flex.Item>
                </Flex>
              </Box>
            </Flex.Item>
          ))}
          <Button
            type="primary"
            size="extra-large"
            onClick={claimSpf}
            disabled={!selectedVestingItem || !selectedVestingItem?.redeemable}
          >
            {!selectedVestingItem ? 'Choose Token Lock' : ''}
            {selectedVestingItem &&
              !selectedVestingItem?.redeemable &&
              `Next unlock date: ${selectedVestingItem.nextUnlock.toFormat(
                `dd-MM-yyyy ${s ? '' : 'HH:mm:ss'}`,
              )}`}
            {selectedVestingItem?.redeemable ? 'Claim SPF' : ''}
          </Button>
        </Flex>
      </Modal.Content>
    </>
  );
};
